document.addEventListener("DOMContentLoaded", function () {
  // const themeToggle = document.getElementById("theme-toggle");

  // localStorage.setItem("theme", "dark");

  // if (localStorage.getItem("theme") === "dark") {

  if([
      '/',
      '/about/',
      '/our-services/',
      '/projects/',
      '/careers/',
  ].includes(window.location.pathname)) {
    document.documentElement.style.background = ''
  }
  document.documentElement.classList.add("dark");
  document.documentElement.dataset.theme = "dark";
  // }

  // document.documentElement.classList.toggle(
  //   "dark",
  //   localStorage.getItem("theme") === "dark" ||
  //     (!("theme" in localStorage) &&
  //       window.matchMedia("(prefers-color-scheme: dark)").matches)
  // );

  // themeToggle.addEventListener("click", function () {
  //   document.documentElement.classList.toggle("dark");

  //   if (document.documentElement.classList.contains("dark")) {
  //     localStorage.setItem("theme", "dark");
  //     document.documentElement.dataset.theme = "dark";
  //   } else {
  //     localStorage.setItem("theme", "light");
  //     document.documentElement.dataset.theme = "light";
  //   }
  // });

  //Get current year for usage
  document.getElementById("year").textContent = new Date().getFullYear();
});

document.addEventListener("DOMContentLoaded", () => {
  const breadcrumbLink = document.getElementById("dynamic-breadcrumb");
  if (!breadcrumbLink) return;

  const path = window.location.pathname;

  const firstSegment = path.split("/").filter(Boolean)[0];

  const labelMap = {
    blog: "Blog",
    projects: "Projects",
  };

  const label = labelMap[firstSegment] || firstSegment || "";

  breadcrumbLink.href = `/${firstSegment}/`;
  breadcrumbLink.textContent = label.charAt(0).toUpperCase() + label.slice(1);
});

document.querySelectorAll("ul").forEach((ul) => {
  const hasImageInLi = Array.from(ul.querySelectorAll("li")).some((li) =>
    li.querySelector("img")
  );

  if (hasImageInLi) {
    ul.classList.add("list__key-benefits");
  }
});

document.addEventListener("DOMContentLoaded", () => {
  const currentPath = window.location.pathname.replace(/\/$/, "");
  const navLinks = document.querySelectorAll("nav a");

  navLinks.forEach((link) => {
    const linkPath = link.getAttribute("href").replace(/\/$/, "");

    if (linkPath === "" || linkPath === "/") return;

    if (currentPath === linkPath) {
      link.classList.add("active");
    }
  });
});
